module.exports = __webpack_public_path__ + "img/bar_chart_black_24dp.4e035ec4.svg";